var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60002 7.00039C1.60002 4.01805 4.01769 1.60039 7.00002 1.60039C9.98236 1.60039 12.4 4.01805 12.4 7.00039C12.4 9.98273 9.98236 12.4004 7.00002 12.4004C4.01769 12.4004 1.60002 9.98273 1.60002 7.00039ZM7.00002 0.400391C3.35494 0.400391 0.400024 3.35531 0.400024 7.00039C0.400024 10.6455 3.35494 13.6004 7.00002 13.6004C10.6451 13.6004 13.6 10.6455 13.6 7.00039C13.6 3.35531 10.6451 0.400391 7.00002 0.400391ZM7.39995 3.6C7.39995 3.26863 7.13132 3 6.79995 3C6.46858 3 6.19995 3.26863 6.19995 3.6V7.2C6.19995 7.42726 6.32835 7.63502 6.53162 7.73666L8.93162 8.93666C9.22801 9.08485 9.58841 8.96472 9.73661 8.66833C9.8848 8.37194 9.76467 8.01154 9.46828 7.86334L7.39995 6.82918V3.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.e4d94d609318a47720efcdc92635f827.svg";
export { ForwardRef as ReactComponent };